export default __webpack_public_path__ + "static/media/adaptive_control_unit.f814242c.png";